const StationsData = [
    [
      "12008",
      "Windsor Downtown",
      "467 University Ave. W. ",
      1969,
      42.31633333333333,
      -83.04366666666667,
      "4",
      "A/RS/C/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      "T",
      "."
    ],
    [
      "12016",
      "Windsor West",
      "College Ave./South St.",
      1975,
      42.29288888888889,
      -83.07313888888889,
      "4",
      "A/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      ".",
      "T"
    ],
    [
      "13001",
      "Chatham",
      "435 Grand Ave. W.",
      2005,
      42.40369444444444,
      -82.20830555555555,
      "15",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "14111",
      "Sarnia",
      "700 Christina St. N.",
      2016,
      42.99027777777778,
      -82.39533333333334,
      "3",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      ".",
      "T"
    ],
    [
      "15020",
      "Grand Bend",
      "Point Blake Conservation Area",
      1991,
      43.333083333333335,
      -81.74288888888888,
      "5",
      "A/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "15026",
      "London",
      "42 St. Julien St.",
      2013,
      42.974472222222225,
      -81.20086111111111,
      "5",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "16015",
      "Port Stanley",
      "43665 Dexter Line, Elgin Water T. Plant",
      2002,
      42.67208333333333,
      -81.1628888888889,
      "5",
      "A/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "18007",
      "Tiverton",
      "4th Concession/Bruce Rd. 23",
      1979,
      44.31447222222222,
      -81.54972222222221,
      "4",
      "A/N",
      "Y",
      ".",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "21005",
      "Brantford",
      "324 Grand River Ave.",
      2004,
      43.13861111111111,
      -80.29263888888889,
      "5",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "26060",
      "Kitchener",
      "West Ave./Homewood Ave. ",
      1990,
      43.44383333333333,
      -80.50380555555556,
      "5",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "27067",
      "St. Catharines",
      "Argyle Cres., Pump Stn.",
      1987,
      43.16005555555555,
      -79.23475,
      "4",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "28028",
      "Guelph",
      "Exhibition St./Clark St. W. ",
      2000,
      43.55161111111111,
      -80.26416666666667,
      "4",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "29000",
      "Hamilton Downtown",
      "Elgin St./Kelly St. ",
      1987,
      43.257777777777775,
      -79.86166666666666,
      "4",
      "A/RS/C/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      "T",
      "T"
    ],
    [
      "29118",
      "Hamilton West",
      "Main St. W./Highway 403",
      1985,
      43.257444444444445,
      -79.90775000000001,
      "3",
      "A/RS/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "29214",
      "Hamilton Mountain",
      "250 Fennell Ave. W.",
      2019,
      43.24122222222222,
      -79.88941666666668,
      "3",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      ".",
      "."
    ],
    [
      "31129",
      "Toronto Downtown",
      "55 John St., Metro Hall",
      2019,
      43.64541666666667,
      -79.38908333333335,
      "2",
      "A/RS/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "33003",
      "Toronto East",
      "Kennedy Rd./Lawrence Ave. E. ",
      1970,
      43.74791666666667,
      -79.27405555555555,
      "4",
      "A/RS/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "34021",
      "Toronto North",
      "4905 Dufferin St., ECCC",
      1988,
      43.78161111111111,
      -79.41772222222222,
      "5",
      "A/RS/C/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      "T",
      "."
    ],
    [
      "35125",
      "Toronto West",
      "125 Resources Rd.",
      2003,
      43.70944444444445,
      -79.5435,
      "8",
      "A/RS/C/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      "T",
      "."
    ],
    [
      "44008",
      "Burlington",
      "North Shore Blvd. E./Lakeshore Rd. ",
      1979,
      43.31511111111111,
      -79.8026388888889,
      "5",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "44017",
      "Oakville",
      "Eigth Line/Glenashton Dr., Halton Reservoir",
      2003,
      43.486916666666666,
      -79.70227777777778,
      "12",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "44029",
      "Milton",
      "1120 Main St. E.",
      2019,
      43.52963888888889,
      -79.86244444444444,
      "4",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      ".",
      "."
    ],
    [
      "45027",
      "Oshawa",
      "Brittania Ave. W., EP Taylor Stables",
      2005,
      43.952083333333334,
      -78.91255555555556,
      "7",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "46090",
      "Brampton",
      "109 McLaughlin Rd. S.",
      2000,
      43.69875,
      -79.78091666666667,
      "5",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "46108",
      "Mississauga",
      "3359 Mississauga Rd. N., U of T Campus",
      2007,
      43.54697222222222,
      -79.65869444444445,
      "5",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "47045",
      "Barrie",
      "83 Perry St.",
      2001,
      44.38236111111111,
      -79.70230555555555,
      "5",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "48006",
      "Newmarket",
      "Eagle St. W./McCaffrey Rd.",
      2001,
      44.04430555555555,
      -79.48325,
      "5",
      "A/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "49005",
      "Parry Sound",
      "7 Bay St.",
      2001,
      45.33786111111112,
      -80.03816666666667,
      "5",
      "A/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "49010",
      "Dorset",
      "1026 Bellwood Acres Rd.",
      1981,
      45.22427777777778,
      -78.93294444444444,
      "3",
      "A/N",
      "Y",
      ".",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "51001",
      "Ottawa Downtown",
      "Rideau St./Wurtemberg St.",
      1971,
      45.43433333333333,
      -75.676,
      "4",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      "T",
      "."
    ],
    [
      "51010",
      "Petawawa",
      "Petawawa Research Forest Facility",
      2007,
      45.996722222222225,
      -77.44119444444445,
      "6",
      "A/N",
      "Y",
      ".",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "52023",
      "Kingston",
      "23 Beechgrove Lane",
      2014,
      44.219861111111115,
      -76.52113888888888,
      "5",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "54012",
      "Belleville",
      "2 Sidney St., Water Treatment Plant",
      2002,
      44.150527777777775,
      -77.39550000000001,
      "10",
      "A/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "56051",
      "Cornwall",
      "Bedford St./3rd St. W.",
      1970,
      45.01797222222222,
      -74.73522222222222,
      "4",
      "A/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "59006",
      "Peterborough",
      "10 Hospital Dr.",
      1998,
      44.30191666666666,
      -78.34622222222222,
      "10",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "63203",
      "Thunder Bay",
      "421 James St. S. ",
      2004,
      48.37938888888889,
      -89.29016666666666,
      "15",
      "A/RS/C/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "71078",
      "Sault Ste. Marie",
      "Sault College",
      2004,
      46.53319444444444,
      -84.30991666666667,
      "8",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      ".",
      "T"
    ],
    [
      "75010",
      "North Bay",
      "Chippewa St. W., Dept. National Defence",
      1979,
      46.32319444444445,
      -79.44927777777778,
      "4",
      "A/RS/N",
      "Y",
      "T",
      "T",
      "T",
      ".",
      ".",
      "."
    ],
    [
      "77233",
      "Sudbury",
      "155 Elm St.",
      2013,
      46.49194444444444,
      -81.00311111111111,
      "3",
      "A/C/N",
      "Y",
      "T",
      "T",
      "T",
      "T",
      ".",
      "."
    ]
  ]
export default StationsData;
